import { render } from "./BaseRadioGroup.vue?vue&type=template&id=5d02093c"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__